import { FC } from 'react'
import {
  DefaultFormContainer,
  FormItemTitle,
  ContainerWithLeftBar,
  AddressOptions,
  FormInputErrorMessage,
} from './styles'
import { LeftBar } from '../../basic/LeftBar'
import OptionButton from '../../basic/OptionButton'
import FileData from 'src/dtos/fileData'
import FilePicker from '../../../components/basic/FilePicker'
import { uploadFiles } from '../../../services/apiClient'
import { useErrors } from 'src/context/errors'
import { ValidationErrorMessage } from 'src/components/basic/ValidationErrorMessage/ValidationErrorMessage'
import {FILE_SIZE_LABEL} from "../../../utils/constants";

interface OptionFileProps {
  title: string;
  setFilesData?: (fileData: FileData[] | undefined) => void;
  filesData?: FileData[];
  fileHint?: string;
  showOptions?: boolean;
  selectedOption?: boolean;
  setSelectedOption?: (option: boolean) => void;
  isIncorrect?: boolean;
  fontSize?: string;
  errorCode?: string;
}

const OptionFile: FC<OptionFileProps> = ({
  title,
  fileHint,
  showOptions,
  setFilesData,
  filesData,
  selectedOption,
  setSelectedOption,
  isIncorrect,
  fontSize,
  errorCode ='',
}) => {
  const { hasError } = useErrors()
  isIncorrect = hasError(errorCode) || isIncorrect

  
  const handleOptionButton = (option: boolean) => {
    if (!!setSelectedOption) {
      setSelectedOption(option)
      if (!option) {
        if (setFilesData) {
          setFilesData(undefined)
        }
      }
    }
  }

  const handleFileSelect = async (files: File[]) => {
    if(files.length > 0) {
      const response = await uploadFiles(files)
      if (setFilesData)
        setFilesData(response)
    } else {
      if (setFilesData)
        setFilesData(undefined)
    }
  }

  return (
    <DefaultFormContainer>
      {fontSize === 'small' ?
        <div style={{ fontSize: '16px', color: '#353744', fontWeight: 900 }}>
          {title}
        </div>
        :
        <FormItemTitle>{title}</FormItemTitle>
      }
      {showOptions ? (
        <>
          <AddressOptions>
            <OptionButton
              checked={selectedOption === true}
              onChange={() => handleOptionButton(true)}
              isIncorrect={isIncorrect && selectedOption === undefined}
              errorCode={errorCode}
            >
              Yes
            </OptionButton>
            <OptionButton
              checked={selectedOption === false}
              onChange={() => handleOptionButton(false)}
              isIncorrect={isIncorrect && selectedOption === undefined}
              errorCode={errorCode}
            >
              No
            </OptionButton>
          </AddressOptions>
          <ValidationErrorMessage errorCode={errorCode} />
          {/* {isIncorrect && selectedOption === undefined ? (
            <FormInputErrorMessage>
              This is a required field
            </FormInputErrorMessage>
          ) : null} */}
        </>
      ) : null}
      {(!showOptions || (showOptions === true && selectedOption === true)) ? (
        <ContainerWithLeftBar inputMaxWidth='440px'>
          <LeftBar />
          <div className='content'>
            <FilePicker
              accept='.doc,.docx,application/msword, application/pdf'
              title={`${fileHint}. ${FILE_SIZE_LABEL}`}
              onFilesSelect={handleFileSelect}
              selectedFiles={!!filesData ? filesData : []}
              limit={100}
              isIncorrect={isIncorrect}
              errorMessage={isIncorrect ? 'This is a required field' : ''}
              fontSize='small'
            />
          </div>
        </ContainerWithLeftBar>
      ) : null}
    </DefaultFormContainer>
  )
}

export default OptionFile